import { defineMessages } from 'react-intl'

const scope = `procurify.core.components.UserLabel`

export default defineMessages({
  delegatedToLabel: {
    id: `${scope}.delegatedToLabel`,
    defaultMessage: 'delegated to {delegateeFullName}',
  },
})
